import { ChangeDetectionStrategy, Component, input, OnInit } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { Blf } from 'src/app/models/centrex/blf';
import { BlfType } from 'src/app/models/centrex/blftype';
import { BlfsFormComponent } from './blfs-form/blfs-form.component';

@Component({
    selector: 'app-blfs',
    imports: [MatTabsModule, BlfsFormComponent],
    templateUrl: './blfs.component.html',
    styleUrl: './blfs.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BlfsComponent implements OnInit {
    // Input de la liste des types de BLFs
    blfsTypes = input.required<BlfType[]>();

    // Input des BLFs du périphériques
    blfs = input.required<Blf[]>();

    // Input pour indiquer si c'est pour des BLFs pour les extenders
    isExtenders = input<boolean>(false);

    ngOnInit(): void {
        if (this.isExtenders() === true) {
            if (this.blfs().length === 0) {
                for (let index = 0; index < 60; index++) {
                    let blf = new Blf();
                    blf.lineKey = index + 1;
                    blf.type = this.blfsTypes()[0].type;
                    blf.value = '';
                    blf.label = '';
                    blf.lineEntry = 0;
                    this.blfs().push(blf);
                }
            }
        } else {
            if (this.blfs().length === 0) {
                for (let index = 0; index < 27; index++) {
                    let blf = new Blf();
                    blf.lineKey = index + 1;
                    blf.type = this.blfsTypes()[0].type;
                    blf.value = '';
                    blf.label = '';
                    blf.lineEntry = 0;
                    this.blfs().push(blf);
                }
            }
        }
    }

    getFilteredBlfs(start: number, end: number): any[] {
        return this.blfs().slice(start, end);
    }
}
